import Vue from 'vue';
import axios from 'axios';
import store from '@/store';
import apiUtil from '@/utils/apiUtil';

const axiosPlugin = {
    install() {
        axios.defaults.headers.common['Accept'] = 'application/json';
        axios.defaults.withCredentials = true;
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

        this.setupContentTypes();
        this.setupMethodSpoofing();
        this.setupLoading();
    },
    setupContentTypes() {
        // Axios does not use default content-type headers. Set the
        // headers depending on the request method
        axios.interceptors.request.use(function(config) {
            // Use 'multipart/form-data' for POST and PUT to upload files.
            if (config.method == 'post' || config.method == 'put') {
                const headers = {
                    ...config.headers.common,
                    ...{ 'Content-Type': 'multipart/form-data' }
                };
                config = { ...config, ...{ headers } };

                // Convert data to FormData
                if (!!config.data && !(config.data instanceof FormData)) {
                    const formData = apiUtil.objectToFormData(config.data);
                    config.data = formData;
                }
            }
            return config;
        });
    },
    setupMethodSpoofing() {
        // Laravel backend requires method spoofing for PUT.
        // Documentation also mentions DELETE, but DELETE works normally
        axios.interceptors.request.use(function(config) {
            if (config.method != 'put') return config;

            config.method = 'post';

            if (config.data instanceof FormData) {
                config.data.append('_method', 'put');
            } else {
                config.data && (config.data['_method'] = 'PUT');
            }
            return config;
        });
    },
    setupLoading() {
        // Use axios interceptors to count pending requests and set
        // the app's loading state accordingly

        let requestsPending = 0;
        const addPending = () => {
            requestsPending++;
            store.commit('app/SET_LOADING', true);
        };
        const subtractPending = () => {
            requestsPending--;
            if (requestsPending <= 0) {
                store.commit('app/SET_LOADING', false);
            }
        };

        axios.interceptors.request.use(
            function(config) {
                addPending();
                return config;
            },
            function(error) {
                subtractPending();
                return Promise.reject(error);
            }
        );

        axios.interceptors.response.use(
            function(response) {
                subtractPending();
                return response;
            },
            function(error) {
                subtractPending();
                return Promise.reject(error);
            }
        );
    }
};

Vue.use(axiosPlugin);
